import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
import { Accordion, AccordionContext, Card, OverlayTrigger, Tooltip, useAccordionToggle } from "react-bootstrap";
import ProjectTable from "./ProjectTable";
import { GetCMEGroupHeadProjectTimeLogExcelExport } from "../../../../services/api/dashboard-api";
import { DashboardExport } from "../../../../assets/icons";
import DownChevron from "../../../../assets/icons/Down_Chevron_20px_Black.svg";
import RightChevron from "../../../../assets/icons/Right_Chevron_20px_Black.svg";
import "../../dashboard-cme/dashboard-cme.scss";

const CMEGroupHeadProjectTimeLog = (props) => {
    const [projects, setProjects] = useState(props.items ? props.items : null);

    useEffect(() => {
        if (props.items) setProjects(props.items);
    }, [props]);

    const DormantHeader = ({ eventKey, callback, isCurrentEventKey, title, count }) => {
        const currentChevronIcon = isCurrentEventKey ? DownChevron : RightChevron;
        const decoratedOnClick = useAccordionToggle(
            eventKey,
            () => callback && callback(eventKey),
        );

        return (
            <button
                key="expand"
                className="dormantHeader"
                onClick={decoratedOnClick}
                onKeyDown={decoratedOnClick}
                tabIndex="0"
                data-testid="dormant-header-click"
                id="dormant-header-click"
            >
                <img src={currentChevronIcon} className="dormantChevron" alt="dormantChevron" />
                <span>{title} ({count})</span>
            </button>
        );
    };

    const DormantAccordion = ({ eventKey, callback }) => {
        const currentEventKey = useContext(AccordionContext);
        const isCurrentEventKey = currentEventKey === eventKey;

        return (
            <DormantHeader
                eventKey={eventKey}
                callback={callback}
                isCurrentEventKey={isCurrentEventKey}
                title="Dormant/Completed/Archived Projects"
                count={projects?.Dormant?.length}
            />
        );
    };

    return (
        <div className="new-dashboard table-wrapper mt-4">
            <div className="DashboardTableWrapper CMEDashboard">
                <div>
                    <div className="DashboardTableHeader">
                        <th className="DashboardTableTitle">
                            Deal Tracker
                            <button
                                key="download"
                                className="DashboardTableHeaderButtons bg-transparent"
                                onClick={GetCMEGroupHeadProjectTimeLogExcelExport}
                                onKeyDown={GetCMEGroupHeadProjectTimeLogExcelExport}
                                tabIndex="0"
                                data-testid="export-button"
                            >
                                <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Export Data</Tooltip>}
                                >
                                    <img src={DashboardExport} alt="Export CME"/>
                                </OverlayTrigger>
                            </button>
                            <div className="subDepartmentTitle">GIB/CME</div>
                        </th>
                    </div>
                </div>
                {   projects?.Active.length > 0 &&
                    <ProjectTable
                        projects={projects}
                        isDormant={false}
                    />
                }
                <Accordion>
                    <div className="dormantContainer">
                        <DormantAccordion eventKey="0" />
                        <Accordion.Collapse eventKey="0">
                            <Card.Body>
                                {   projects?.Dormant.length > 0 &&
                                    <ProjectTable
                                        projects={projects}
                                        isDormant={true}
                                    />
                                }
                            </Card.Body>
                        </Accordion.Collapse>
                    </div>
                </Accordion>
            </div>
        </div>
    );
};

CMEGroupHeadProjectTimeLog.propTypes = {
    items: PropTypes.arrayOf(
        PropTypes.shape({
          Project: PropTypes.shape({
            Id: PropTypes.number.isRequired,
            Name: PropTypes.string.isRequired,
            Owner: PropTypes.shape({
              Id: PropTypes.number.isRequired,
              Name: PropTypes.string.isRequired,
            }).isRequired,
            Members: PropTypes.arrayOf(
              PropTypes.shape({
                Id: PropTypes.number.isRequired,
                Name: PropTypes.string.isRequired,
              })
            ).isRequired,
          }).isRequired,
          ProjectDynamicFields: PropTypes.arrayOf(
            PropTypes.shape({
              Label: PropTypes.string.isRequired,
              Data: PropTypes.string.isRequired,
            })
          ).isRequired,
          ProjectMembers: PropTypes.arrayOf(PropTypes.shape({
            UserId: PropTypes.string,
            IsViolation: PropTypes.bool,
            AnalystAssociate: PropTypes.string,
            MFHours: PropTypes.string,
            SaturdayHours: PropTypes.string,
            SundayHours: PropTypes.string,
            TotalHours: PropTypes.string,
            Workload: PropTypes.string,
            LastUpdated: PropTypes.string
        })),
            AggregateMFHours: PropTypes.string.isRequired,
            AggregateSaturdayHours: PropTypes.string.isRequired,
            AggregateSundayHours: PropTypes.string.isRequired,
            AggregateTotalHours: PropTypes.string.isRequired,
            Description: PropTypes.string.isRequired,
            LastUpdated: PropTypes.string,
            IsViolation: PropTypes.bool.isRequired,
            QtyMembers: PropTypes.number.isRequired,
            Staffer: PropTypes.shape({
              Id: PropTypes.number.isRequired,
              Name: PropTypes.string.isRequired,
            }).isRequired,
        })
      ),
};

export default CMEGroupHeadProjectTimeLog;
